import gql from "graphql-tag";
import defaultCache from "@/graphql/breadcrumbsMeta/defaultCache";
import { breadcrumbsQuery } from "@/graphql/breadcrumbsMeta/queries";

export default {
	typeDefs: gql`
		type BreadcrumbsMeta {
			label: String
			label2: String
			label3: String
			id: String
			id2: String
			id3: String
		}

		type Mutation {
			changeBreadcrumbsMetaMutation(label: String, label2: String, label3: String, id: String, id2: String, id3: String): Boolean
		}
	`,
	resolvers: {
		Mutation: {
			changeBreadcrumbsMetaMutation: (parent, changes, { cache }) => {
				const data = cache.readQuery({ query: breadcrumbsQuery });

				Object.keys(changes).forEach(key => {
					data.breadcrumbsMeta[key] = changes[key];
				});

				cache.writeQuery({ query: breadcrumbsQuery, data });

				return data;
			},
			clearBreadcrumbsMetaMutation: (parent, changes, { cache }) => {
				const data = { breadcrumbsMeta: defaultCache };

				cache.writeQuery({ query: breadcrumbsQuery, data });

				return data;
			}
		}
	}
};



// WEBPACK FOOTER //
// ./src/graphql/breadcrumbsMeta/resolvers.js